// removed by extract-text-webpack-plugin
module.exports = {"content":"ZV0Yzxu-W3EKsJ-opVVob","button":"frKYO7IOOCrgba00v0pNA","flash":"_3NlyZBGHqm4S3R0ZrKdRz_","active":"_1FwVe-TDEL_0zo_ndN0sLj"};


//////////////////
// WEBPACK FOOTER
// ../components/carousel/styles.module.css
// module id = 470
// module chunks = 0